import React from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import Icon from '../../../app/common/components/Icon';
import ICONS from '../../../app/common/constants/icons';
import { IAddress } from './address.interface';
import { AddressFormatter } from './addressFormatter.service';
import { AddressWrapper, BillingNotes, ControlButtons, ButtonInline } from './Address';
import styled from 'styled-components';
import { MQS } from '../../../app/common/constants/styles';
import AddressFormat from './addressFormat';
import { SupportedLanguage } from '../../../config/constants/supportedLanguage.enum';
import { ICountryMap } from '../../../app/common/fields/country/country';

interface IAddressProps {
    address: IAddress;
    cards?: string[];
    deleteAddress: (addressUuid: string) => void;
    intl: InjectedIntl;
    isOnlyAddress?: boolean;
    onEdit: (address: IAddress) => void;
    setDefaultShipping: (address: IAddress, isShipping: boolean) => void;
    qaId?: string;
    locale: SupportedLanguage;
}

const Left = styled.div`
    @media (min-width: ${MQS.mq1Max}) {
        max-width: 90%;
    }
`;

const Right = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${MQS.mq1Max}) {
        max-width: 10%;
    }
`;

class Address extends React.Component<IAddressProps> {
    constructor(props: IAddressProps) {
        super(props);
    }

    public render() {
        const { address, onEdit, qaId, locale } = this.props;

        const onEditClick = () => {
            onEdit(address);
        };

        return (
            <AddressWrapper data-qa-id={`address-${qaId}`} className={'notranslate'}>
                <Left className="info">
                    <AddressFormat
                        locale={locale}
                        address={address}
                        displayIcon={true}
                    ></AddressFormat>
                </Left>
                <Right>
                    <div></div>
                    <ControlButtons>
                        <ButtonInline title="Edit" onClick={onEditClick} data-qa-id="edit-address">
                            <Icon icon={ICONS.EDIT} />
                        </ButtonInline>
                    </ControlButtons>
                </Right>
            </AddressWrapper>
        );
    }
}

export default injectIntl(Address);
